/**
 * login标签数据接口文档
 */
import { Method } from '../core';
import { API, SOURCE } from '../config';

const api = API;

export default {
  // 登陆
  login: {
    url: `${api}/rest/v1/login`,
    method: Method.POST,
    body: {
      account: {
        $type: String,
        $required: true
      },
      pwd: {
        $type: [Number, String],
        $required: true
      },
      type: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      },
      crm: {
        $type: Object
      }
    }
    // mode: Mode.fetch
  },
  config: {
    url: `${api}/rest/v1/login/config/63`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 退出
  logout: {
    url: `${api}/rest/v1/logout`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 定制退出
  customelogout: {
    url: `${api}/rest/v1/logout/third/yonyou`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 验证码
  send: {
    url: `${api}/rest/v1/code/send`,
    method: Method.GET,
    body: {
      // 手机号
      account: {
        $type: String
      },
      // type 类型
      type: {
        $type: Number
      },
      flowId: {},
      // 状态
      source: {
        $type: String,
        $default: SOURCE
      }
    }
    // mode: Mode.fetch
  },
  beforeSend: {
    url: `${api}/rest/v1/code/robotAuth/apply`,
    method: Method.POST,
    body: {
      // 手机号
      principal: {
        $type: String
      },
      // type 类型
      clientType: {
        $type: String,
        $default: 'web'
      },
      // 状态
      source: {
        $type: String,
        $default: 'esign'
      }
    }
    // mode: Mode.fetch
  },
  newSend: {
    url: `${api}/rest/v1/code/robotAuth/send`,
    method: Method.POST,
    body: {
      // 手机号
      account: {
        $type: String
      },
      // type 类型
      type: {
        $type: Number
      },
      robotAuth: {},
      // 状态
      source: {
        $type: String,
        $default: 'esign'
      }
    }
    // mode: Mode.fetch
  },
  // 银行四要素 信息对比 获取验证码
  bankInfo: {
    url: `${api}/rest/v1/realname/person/bank/info`,
    method: Method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      name: {
        $type: String
      },
      // 银行卡
      cardno: {
        $type: String
      },
      // 身份证号
      idno: {
        $type: String
      },
      // 银行预留手机号
      mobile: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 银行四要素 获取验证码后提交
  bankCode: {
    url: `${api}/rest/v1/realname/person/bank/code`,
    method: Method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      // 返回的 service id
      serviceId: {
        $type: String
      },
      // 验证码
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 个人三要素 信息比较
  individuaInfo: {
    url: `${api}/rest/v1/realname/person/telecom/info`,
    method: Method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      // name
      name: {
        $type: String
      },
      // 身份证
      idno: {
        $type: String
      },
      // 手机号
      mobile: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 个人web/个人h5 提交个人用户信息 获取实名url
  getpersonAuthUrl: {
    url: `${api}/rest/v1/realname/person/getAuthUrl`,
    method: Method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      // name
      name: {
        $type: String
      },
      refresh: {
        $type: Number,
        $required: false
      },
      authId: {
        $type: String,
        $required: false
      },
      // 身份证
      idNo: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 个人web/个人h5/企业web 获取认证结果
  getAuthResult: {
    url: `${api}/rest/v1/realname/getAuthResult`,
    method: Method.GET,
    body: {
      authId: {
        $type: String
      },
      userType: {
        $type: Number
      },
      source: {
        $type: String,
        $default: SOURCE
      },
      queryFromAuthService: {
        $type: Boolean
      }
    }
  },
  // 个人 验证码
  individuaCode: {
    url: `${api}/rest/v1/realname/person/telecom/code`,
    method: Method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      // 返回的 service id
      serviceId: {
        $type: String
      },
      // 验证码
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 个人或企业注册
  regist: {
    url: `${api}/rest/v1/account/regist`,
    method: Method.POST,
    body: {
      account: {
        $type: String
      },
      type: {
        $type: Number
      },
      pwd: {
        $type: String
      },
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      },
      crm: {
        $type: Object
      }
    }
  },
  // 企业信息校验
  groupInfoCheck: {
    url: `${api}/rest/v1/realname/organ/check`,
    method: Method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      name: {
        $type: String
      },
      codeUSC: {
        $type: String
      },
      legalName: {
        $type: String
      },
      legalIdno: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 企业打款
  groupPay: {
    url: `${api}/rest/v1/realname/organ/pay`,
    method: Method.POST,
    body: {
      bankAccount: {
        $type: String
      },
      cardno: {
        $type: String
      },
      bank: {
        $type: String
      },
      subbranch: {
        $type: String
      },
      provice: {
        $type: String
      },
      city: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 企业web 提交企业相关信息获取url
  getgroupAuthUrl: {
    url: `${api}/rest/v1/realname/organ/getAuthUrl`,
    method: Method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      organName: {
        $type: String
      },
      licenseCode: {
        $type: String
      },
      legalName: {
        $type: String
      },
      legalIdNo: {
        $type: String
      },
      licenseType: {
        $type: Number,
        $default: 2
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 企业打款验证
  paycheck: {
    url: `${api}/rest/v1/realname/paycheck`,
    method: Method.POST,
    body: {
      reRealName: {
        $type: Boolean,
        $default: false
      },
      cash: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 找回密码
  forget: {
    url: `${api}/rest/v1/account/loginpwd/forget`,
    method: Method.POST,
    body: {
      account: {
        $type: String
      },
      pwd: {
        $type: String
      },
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 设置签署密码
  setPwd: {
    url: `${api}/rest/v1/account/signpwd/set`,
    method: Method.PUT,
    body: {
      pwd: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 用户状态 /rest/v1/account/status/get
  userStatusApi: {
    url: `${api}/rest/v1/account/status/get`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 第三方登录 轮询接口 /rest/v1/loginReturn/getState
  pollLoginState: {
    url: `${api}/rest/v1/loginReturn/getState`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      uniqueId: {
        $type: String
      }
    }
  },
  // 第三方登录 绑定账号 /rest/v1/login/bind
  accountBind: {
    url: `${api}/rest/v1/login/bind`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      // 绑定账户
      account: {
        $type: String
      },
      // 第三方 id
      thirdPartyUserId: {
        $type: String
      },
      //  第三方 key
      thirdPartyKey: {
        $type: String
      },
      // 绑定账号 验证类型 0-验证码 1-密码 默认-0
      type: {
        $type: Number
      },
      // 验证码
      code: {
        $type: String
      },
      // 密码
      pwd: {
        $type: String
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/login.js